import { Directive, Input, ElementRef, AfterViewInit } from '@angular/core';
import { renderLink } from '../pipes/tracker.text.functions';

@Directive({
  selector: 'render-ti-text'
})
export class RenderTiTextDirective implements AfterViewInit {
  @Input() text: string;

  constructor(private elementRef: ElementRef) {}

  ngAfterViewInit() {
    this.renderAndLink();
  }

  private renderAndLink() {
    try {
      let renderedText = this.text;
      renderedText = renderLink(renderedText);
      this.elementRef.nativeElement.innerHTML = renderedText;
    } catch (err) {
      console.error('Error rendering and linking text:', err);
    }
  }
}
